<script>
  // Перенос MetricCard из lib/ui.tsx. Значение НЕ переносится на 2 строки —
  // это держит класс .mv (nowrap + tabular-nums) из styles.css.
  export let label = '';
  export let value = '';
  export let sub = undefined;
  export let gold = false;
  export let goldValue = undefined;
  export let smallValue = false;
</script>

<div class={'ui-metric' + (gold ? ' gold' : '')}>
  <div class="ml">{label}</div>
  <div class={'mv' + ((goldValue ?? gold) ? ' gold' : '') + (smallValue ? ' sm' : '')} title={value}>{value}</div>
  {#if sub != null}<div class="msub">{sub}</div>{/if}
</div>
